
const InterviewDetailsModal = ({ interview, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-screen overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-gray-900">{interview.title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-3">Interview Details</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">Duration:</span>
                  <span>{interview.duration_minutes} minutes</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Status:</span>
                  <span className="capitalize">{interview.status}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">AI Questions:</span>
                  <span>{interview.ai_generated_questions || 0}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Custom Only:</span>
                  <span>{interview.custom_questions_only ? 'Yes' : 'No'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Created:</span>
                  <span>{new Date(interview.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-3">Job Description</h3>
              <div className="text-sm">
                <p className="font-medium">{interview.job_description?.title}</p>
                <p className="text-gray-600">{interview.job_description?.company}</p>
              </div>
            </div>
          </div>

          {interview.description && (
            <div className="mt-6">
              <h3 className="text-lg font-medium text-gray-900 mb-3">Description</h3>
              <p className="text-sm text-gray-600">{interview.description}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default InterviewDetailsModal;